export const CATALOG_FIRST_LEVEL_ROUTE = '[a-z_0-9-]+-([0-9]+)';
// TODO: Remove after refactoring the collection
export const CATALOG_GENERIC_LEVEL_ROUTE = '-([0-9]+)';
export const CATALOG_SELECTION_ROUTE = '[a-z_0-9-]+';
